import React, { useEffect } from 'react'
import './assessment.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchAssessmentList } from '../../../../thunk/hnwHome.thunk';
import { HOME_PAGE } from '../../../../common/homePageConstants';
import Slider from 'react-slick';
import { HNW_ASSESSMENT_PATH_KEYS } from '../../../../common/skinAssessmentConstant';

const Assessment = ({ routeTo }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const { assessmentList } = useSelector(state => state.home);
    const { isAuthTokenSaved } = useSelector(
        (state) => state.tokenStatus,
    );

    const settings = {
        dots: false,
        nav: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 0
    };

    useEffect(() => {
        if (!assessmentList?.length && isAuthTokenSaved) {
            dispatch(fetchAssessmentList());
        }
    }, [isAuthTokenSaved]);

    const route = item => {
        if (item.health_wellness_redirect_path) {
            const redirectPath = item.health_wellness_redirect_path;
            // ถ้าเป็น path จริง (เริ่มด้วย /) ใช้ history.push โดยตรง
            if (redirectPath.startsWith('/')) {
                const hasQuery = redirectPath.includes('?');
                const fullPath = hasQuery
                    ? redirectPath
                    : `${redirectPath}?assessment_id=${item.id}`;
                history.push(fullPath);
            } else {
                // เป็น key ของ commonConstant
                const params = redirectPath.includes('?')
                    ? ''
                    : `?assessment_id=${item.id}`;
                routeTo(redirectPath, params);
            }
        } else if (Object.values(HNW_ASSESSMENT_PATH_KEYS).some(k => k === item.path)) {
            routeTo(item.path, `?assessment_id=${item.id}`);
        } else {
            routeTo(item.path);
        }
    }

    const renderList = (item, index) => {
        return (
            <div onClick={() => route(item)} key={`assessment${index}`} className='assessment-card-container'>
                <img src={item?.imageUrl} className='assessment-card-container-image' />
                <div className='assessment-card-container-content'>
                    <h5 className='assessment-card-container-content-title'>
                        {item?.title}
                    </h5>
                    <button className='assessment-card-container-content-tag'>
                        {HOME_PAGE.ASSESSMENT_BADGE_TEXT}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className='assesment-carousel-container'>
            <h2 className='assessment-section-title'>แบบประเมินสุขภาพ</h2>
            <div className='assessment-carousel-list'>
                <Slider {...settings}>
                    {
                        assessmentList?.length ?
                            assessmentList.filter(item => item.is_show_on_health_wellness).map((item, index) => (
                                renderList(item, index)
                            )) : null
                    }
                </Slider>
            </div>
        </div>
    )
}

export default Assessment